import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { LanguageProvider } from './hooks/useLanguage';
import { ToastProvider } from './components/ui/Toast';
import { initGoogleAnalytics } from './utils/googleAnalytics';
import './index.css';
// Initialize Google Analytics BEFORE React renders
// so the tag is in <head> when Google's checker scans the page
initGoogleAnalytics();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-735">
    <LanguageProvider data-id="element-736">
      <ToastProvider data-id="element-737">
        <App data-id="element-738" />
      </ToastProvider>
    </LanguageProvider>
  </React.StrictMode>);